'use strict';

(() => {
  const emit = (event, detail = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...detail });
    window.Shopify?.analytics?.publish?.(`coozebra:${event}`, detail);
  };

  const mount = root => {
    if (!root || root.dataset.v2) return;
    root.dataset.v2 = '1';

    root.querySelectorAll('[data-co-event]').forEach(link => {
      link.addEventListener('click', () => emit(link.dataset.coEvent, {
        product_id: link.dataset.productId || link.dataset.coCustomizerIntent,
        product_name: link.dataset.productName,
      }));
    });

    const hero = root.querySelector('.co-series-banner-v1__cta');
    const sticky = root.querySelector('.co-v2__sticky');
    const end = root.querySelector('.co-v2__final');
    if (!hero || !sticky) return;

    let heroVisible = true;
    let endVisible = false;
    const syncSticky = () => sticky.classList.toggle('is-visible', !heroVisible && !endVisible);
    new IntersectionObserver(([entry]) => {
      heroVisible = entry.isIntersecting;
      syncSticky();
    }, { threshold: .15 }).observe(hero);
    if (end) {
      new IntersectionObserver(([entry]) => {
        endVisible = entry.isIntersecting;
        syncSticky();
      }, { threshold: .15 }).observe(end);
    }
  };

  document.querySelectorAll('.co-v2.co-landing-root').forEach(mount);
  document.addEventListener('shopify:section:load', event => {
    mount(event.target.matches('.co-v2.co-landing-root')
      ? event.target
      : event.target.querySelector('.co-v2.co-landing-root'));
  });
})();
